import { render, staticRenderFns } from "./CreateOrderByWeight.vue?vue&type=template&id=4ca1fd83&lang=pug&"
import script from "./CreateOrderByWeight.vue?vue&type=script&lang=ts&"
export * from "./CreateOrderByWeight.vue?vue&type=script&lang=ts&"
import style0 from "./CreateOrderByWeight.vue?vue&type=style&index=0&id=4ca1fd83&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports